import React from 'react'
const Contact = props => <article className="media">
  <figure className="media-left" style={{ marginRight: '10px', marginTop: 7 }}>
    <p className="image is-64x64">
      <i className={props.icon}></i>
    </p>
  </figure>
  <div className="media-content">
    <div className="content">
      <p>
        <strong style={{ color: 'white' }}>{props.name}</strong> <small><a style={{ color: 'white' }} href={props.link}>{props.value}</a></small>
        <br />
        {props.desc}
      </p>
    </div>
  </div>
</article>
export default props => <div className='container' style={{ maxWidth: '700px' }}><div className='content bodyfont' style={{ padding: '70px 20px', fontSize: '18px', lineHeight: '1.8em', color: 'white' }}>
  <h1 className='titlefont' style={{ color: 'white', fontSize: '60px' }}>Kontakt</h1>
  <Contact icon='fal fa-at fa-3x' name='Email' value='jadwiga.sikorska3@gmail.com' link='mailto:jadwiga.sikorska3@gmail.com' desc='' />
  <Contact icon='fab fa-facebook fa-3x' name='Facebook' value='Arteco Stargard' link='https://www.facebook.com/pg/Arteco-Stargard-423015501612649/posts/?ref=page_internal' desc='' />
</div></div>


// WEBPACK FOOTER //
// ./src/Kontakt.js